export default "__VITE_ASSET__RTVniS$6__"